export function Wordmark({ className }: { className?: string }) {
  return (
    // The Networking One wordmark is an SVG asset. next/image does not optimize SVG.
    // eslint-disable-next-line @next/next/no-img-element
    <img src="/networking-one.svg" alt="Networking One" className={className} />
  );
}
